// @flow
import * as React from 'react';
import Localize from '@ta/platform.i18n';
import Icon from '@ta/core-ui.icon';
import Button from '@ta/core-ui.button';
import styles from './ShowMore.css';

type Props = {|
  /** Callback after clicking the show more button
   * e.g. to request for data and then toggle off showButton like the activity feed does */
  onClick?: (SyntheticEvent<*>) => mixed,

  /** A boolean of whether there is more data to request */
  hasMore: boolean,

  /** A boolean whether it is initial pageload and the showMore button should be used instead of infinite scroll */
  showButton: boolean,

  /** A boolean whether it is "show more previous" (true) or "show more next" (false) */
  goingBackwards?: boolean,

  /** Any loading skeletons */
  children?: React.Node,
|};

/**
 * Simple component that shows a button which replaces itself with the contents.
 */
const ShowMore = ({ onClick, hasMore, showButton, goingBackwards, children }: Props) => {
  if (!hasMore) {
    return null;
  }

  const onButtonClick = e => {
    if (onClick) {
      onClick(e);
    }
  };

  const iconName = goingBackwards ? 'single-chevron-up' : 'single-chevron-down';

  if (showButton) {
    return (
      <div className={styles.show_more}>
        <Button size="large" onClick={onButtonClick}>
          <div className={styles.button_contents}>
            <span className={styles.button_text}>
              <Localize id="airm_mobile_show_more" />
            </span>
            <span className={styles.button_icon}>
              <Icon name={iconName} />
            </span>
          </div>
        </Button>
      </div>
    );
  }

  return children || null;
};

export default ShowMore;
